module.exports = "images/apple-icon-120x120.09a4615201fe4adef45efd0bf8f0760b.png";